




import { Filter, FilterModel, RangeFilter } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RangeMessages } from '../../../i18n';

@Component
export default class FilterTitle extends Vue {
  @Prop()
  filter: Filter;

  get title() {
    switch (this.filter.modelName) {
      case FilterModel.range:
        return this.getRangeFilterMessage(this.filter as RangeFilter);
      case FilterModel.currencyRange:
        return this.getCurrencyRangeFilterMessage(this.filter as RangeFilter);
      default:
        return this.filter.title;
    }
  }

  private getRangeFilterMessage(filter: RangeFilter) {
    return this.getRangeFilterMessages(filter.facet.modelName, filter.value.min, filter.value.max);
  }

  private getCurrencyRangeFilterMessage(filter: RangeFilter) {
    const facetCurrency = this.$options.filters.facetCurrency;
    const value = filter.value;
    const min = value.min === null ? null : facetCurrency(value.min);
    const max = value.max === null ? null : facetCurrency(value.max);
    return this.getRangeFilterMessages(filter.facet.modelName, min, max);
  }

  private getRangeFilterMessages(facetName: string, min: string | number, max: string | number) {
    const messages = (this.$x.messages.facets.values[facetName] || this.$x.messages.facets.defaultRange) as RangeMessages;
    if (min === null) {
      return this.$options.filters.compileMessage(messages.lessHTML, { max });
    } else if (max === null) {
      return this.$options.filters.compileMessage(messages.fromHTML, { min });
    } else {
      return this.$options.filters.compileMessage(messages.betweenHTML, { max, min });
    }
  }

}
